var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13",
    "data-name": "Rect\\xE1ngulo 13",
    width: 18.369,
    height: 18.41,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_28",
    "data-name": "Rect\\xE1ngulo 28",
    width: 24,
    height: 24,
    fill: "black",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M15.619,1.91H13.93V.75a.762.762,0,0,0-.239-.544A.724.724,0,0,0,13.171,0a.757.757,0,0,0-.741.75V1.91H5.93V.75A.762.762,0,0,0,5.691.206.721.721,0,0,0,5.171,0,.757.757,0,0,0,4.43.75V1.91H2.75A2.753,2.753,0,0,0,0,4.66v11a2.753,2.753,0,0,0,2.75,2.75H15.619a2.753,2.753,0,0,0,2.75-2.75v-11a2.753,2.753,0,0,0-2.75-2.75m1.25,5.58v8.17a1.25,1.25,0,0,1-1.25,1.25H2.75A1.251,1.251,0,0,1,1.5,15.66V7.49Zm-12.2-3.2A.747.747,0,0,0,5.93,3.75V3.41h6.5v.34a.759.759,0,0,0,.237.543A.747.747,0,0,0,13.93,3.75V3.41h1.689a1.251,1.251,0,0,1,1.25,1.25V5.99H1.5V4.66A1.252,1.252,0,0,1,2.75,3.41H4.43v.34a.759.759,0,0,0,.237.543",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M7.924,11.247l.638-.392a.075.075,0,0,1,.114.064v3.459a.3.3,0,0,0,.3.3h.409a.3.3,0,0,0,.3-.3V10.011a.3.3,0,0,0-.3-.3H8.759a.3.3,0,0,0-.154.043l-.764.457a.3.3,0,0,0-.145.258v.65a.15.15,0,0,0,.228.128",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar_black.7d33cc66469d0098ea206eae8c35c540.svg";
export { ForwardRef as ReactComponent };